import React, { memo } from 'react';

import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import { isEmpty, isString } from '@wconcept/wconcept-common/utils/baseUtils';

import * as S from './style';

interface IProps {
  /** background color */
  bgColor?: string;
  /** font color */
  fontColor?: string;
  /** label */
  label?: string;
  /** className */
  className?: string;
  /** icon */
  icon?: React.ReactNode;
  /** children */
  children?: React.ReactNode;
}

const Tag = ({
  label,
  bgColor,
  fontColor,
  className,
  icon,
  children,
}: IProps) => {
  const param = {
    className: classNameBind(['tag', className || '']),
    'aria-label': label,
    icon,
    bgColor,
    fontColor,
  };

  return (
    <S.Tag {...param}>
      {!isEmpty(icon) && icon}
      {!isEmpty(children) && isString(children) ? (
        <span>{children}</span>
      ) : (
        children
      )}
    </S.Tag>
  );
};

export default memo(Tag);
